import styled from 'styled-components';

export const StyledDangerSpan = styled.div`
  color: ${({ theme }) => theme.colors.danger['900']};
  justify-content: right;
  width: 100%;
`;
